<template>
  <v-app id="app">
    <v-content>
      <loading v-show="cargando"></loading>
      <modal v-if="cambiarEstadoModal" @actualizarOpcion="valorOpcion"></modal>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import Loading from "./components/Loading/Loading";
import Modal from "./components/Modal/Modal";
import { refrescarToken } from "./apiService/request/crudUsuario";
import axios from "./apiService/config/axios";

export default {
  name: "app",
  data() {
    return {
      valorSeleccionadoDialogo: ""
    };
  },
  components: {
    Loading,
    Modal
  },
  created() {
    // sessionStorage.clear();
    // setInterval(async () => {
    //   const refreshToken = sessionStorage.getItem("refreshToken");
    //   if (refreshToken) {
    //     const respuesta = await refrescarToken(refreshToken);
    //     if (respuesta && respuesta.data && respuesta.data.data) {
    //       sessionStorage.setItem("token", respuesta.data.data.token);
    //       sessionStorage.setItem(
    //         "refreshToken",
    //         respuesta.data.data.refreshToken
    //       );
    //       sessionStorage.setItem("expiresIn", respuesta.data.data.expiresIn);
    //       axios.defaults.headers.common.Authorization = `Bearer ${sessionStorage.getItem(
    //         "token"
    //       )}`;
    //     }
    //   }
    // }, 1800000);
  },
  computed: {
    cargando() {
      if (this.$store.getters.getCargando != null) {
        return this.$store.getters.getCargando;
      }
      return false;
    },
    cambiarEstadoModal() {
      return this.$store.getters.getEstadoModal;
    }
  },
  methods: {
    valorOpcion: function(valor) {
      this.valorSeleccionadoDialogo = valor;
    }
  }
};
</script>

<style lang="scss">
@import "./assets/sass/main.scss";
#app {
  font-family: "Nunito", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

* {
  margin: 0;
}
</style>
